import { LoadingButton } from "@mui/lab";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { toast } from "react-toastify";

import { useDeleteCaseMutation } from "../../app/case/api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { changeDeletePatientConfirmationModal } from "../../app/modal/slice";
import { useThemeContext } from "../../context/ThemeContext";
import Icon from "../../icons";
import { DeletePatientConfirmationWrapper } from "./styles";

const PhoneConfirmationModal = () => {
  const dispatch = useAppDispatch();
  const [deleteCase, { isLoading }] = useDeleteCaseMutation();
  const { isOpen, caseId } = useAppSelector(
    (state) => state.modalSlice.deletePatientConfirmation
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { mode } = useThemeContext();

  const handleDelete = async () => {
    if (caseId && typeof caseId === "number") {
      await deleteCase(caseId);
      toast.success("Запись успешна удалена");
    }
  };

  const handleCloseModal = () => {
    dispatch(
      changeDeletePatientConfirmationModal({ isOpen: false, caseId: null })
    );
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      PaperProps={{
        sx: {
          boxShadow: "none",
          backgroundImage: "none",
          borderRadius: "20px",
          backgroundColor: "transparent",
        },
      }}
      fullWidth
    >
      <DeletePatientConfirmationWrapper mode={mode}>
        <button
          className="close-button"
          type="button"
          onClick={handleCloseModal}
        >
          <Icon icon="close" />
        </button>
        <DialogContent sx={{ padding: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: 500,
                fontFamily: "Montserrat, sans-serif",
                color: mode === "dark" ? "#F0F0F0" : "#0D0A2C",
              }}
              variant="body2"
            >
              Вы уверены, что хотите удалить пациента?
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LoadingButton
              disabled={isLoading}
              sx={{
                marginRight: "28px",
                width: 146,
                height: 44,
                background: mode === "dark" ? "#353944" : "#647295",
                color: "#F0F0F0",
                borderRadius: "10px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
                fontSize: "16px",
                textTransform: "none",
                "&:hover": {
                  color: "#0D0A2C",
                  background: "#BADAFF",
                },
              }}
              onClick={handleCloseModal}
            >
              Отменить
            </LoadingButton>
            <LoadingButton
              loading={isLoading}
              sx={{
                width: 146,
                height: 44,
                background: mode === "dark" ? "#236BCF" : "#1A509B",
                color: "#F0F0F0",
                borderRadius: "10px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
                fontSize: "16px",
                textTransform: "none",
                "&:hover": {
                  color: "#0D0A2C",
                  background: "#BADAFF",
                },
              }}
              onClick={handleDelete}
            >
              Да
            </LoadingButton>
          </Box>
        </DialogContent>
      </DeletePatientConfirmationWrapper>
    </Dialog>
  );
};

export default PhoneConfirmationModal;
